<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('question.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('question.pageTitle'),
            href: '/questions'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <staff-question-Edit v-if="isStaff" />
  </div>
</template>
<script>
import StaffQuestionEdit from './staff/edit'

export default {
  name: 'questionEdit',
  components: {
    StaffQuestionEdit
  },
  data() {
    return {}
  },
  computed: {
    isStaff() {
      return this.$store.getters.isStaffLogin
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('eschool/eExam/question/SET_EDIT_DATA')
    }
    next()
  }
}
</script>
